import Modal from '../../general/Modal';

interface DeleteItemsDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteItemsDialog({ isOpen, onConfirm, onCancel }: DeleteItemsDialogProps) {
  return (
    <Modal open={isOpen} onClose={onCancel} contanerClassName="w-full max-w-md bg-white shadow-lg">
      <div className="p-6">
        <h3 className="mb-4 text-lg font-semibold text-gray-900">Delete items</h3>
        <p className="mb-6 text-gray-600">Are you sure you want to delete selected items?</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onConfirm}
            className="hover:bg-black-700 cursor-pointer rounded bg-black px-4 py-2 text-white"
          >
            Ok
          </button>
          <button
            onClick={onCancel}
            className="cursor-pointer rounded bg-gray-300 px-4 py-2 text-gray-700 transition-colors hover:bg-gray-400"
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
}
